// action creators
export const setTab = (context, tab) => ({ type: 'tabs/SET_TAB', context, tab })

const initialState = {}

export const tabsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'tabs/SET_TAB':
      return { ...state, [action.context]: action.tab }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/tabs.js